// extracted by mini-css-extract-plugin
export default {"header":"style_header__6ePiw","menu":"style_menu__9VeQx"};